import React from 'react';
import PropTypes from 'prop-types';

import Boomerang from '~/src/components/svg/general/Boomerang';

import css, {breakpointTablet} from './VideoSeriesCarousel.module.scss';

class VideoSeriesCarousel extends React.Component {
    scrollToSelectedTeaser() {
        if (this.props.carouselStartPos !== 0) {
            const teasersElement = this.teasers.current;
            const elementWidth = teasersElement.offsetWidth;
            const elementScrollWidth = teasersElement.scrollWidth;
            const maxScrollPosition = elementScrollWidth - elementWidth;
            const scrollElement = teasersElement.children[this.props.carouselStartPos];

            let scrollOffset = 20;
            if (window.screen.width < parseInt(breakpointTablet)) {
                scrollOffset = (elementWidth - scrollElement.offsetWidth) / 2;
            }
            const newScrollPos = scrollElement.offsetLeft - scrollOffset;

            if (teasersElement.scrollTo) {
                teasersElement.scrollTo({
                    left: newScrollPos,
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                teasersElement.scrollLeft = newScrollPos;
            }

            if (newScrollPos > maxScrollPosition) {
                this.setState({
                    showLeftArrow: true,
                    showRightArrow: false
                });
            } else if (newScrollPos === 0) {
                this.setState({
                    showLeftArrow: false,
                    showRightArrow: true
                });
            } else {
                this.setState({
                    showLeftArrow: true,
                    showRightArrow: true
                });
            }
        }
    }

    scroll(scrollDir) {
        const teasersElement = this.teasers.current;
        const elementWidth = teasersElement.offsetWidth;
        const elementScrollWidth = teasersElement.scrollWidth;
        const maxScrollPosition = elementScrollWidth - elementWidth;
        const currentScrollPos = teasersElement.scrollLeft;
        let newScrollPos;

        if (scrollDir === 'left') {
            if (currentScrollPos - elementWidth > 0) {
                newScrollPos = currentScrollPos - elementWidth;
            } else {
                newScrollPos = 0;
            }
        } else {
            if (currentScrollPos + elementWidth <= maxScrollPosition) {
                newScrollPos = currentScrollPos + elementWidth;
            } else {
                newScrollPos = elementScrollWidth - elementWidth;
            }
        }

        if (teasersElement.scrollTo) {
            teasersElement.scrollTo({
                left: newScrollPos,
                top: 0,
                behavior: 'smooth'
            });
        } else {
            teasersElement.scrollLeft = newScrollPos;
        }

        if (newScrollPos === 0) {
            this.setState({
                showLeftArrow: false,
                showRightArrow: true
            });
        } else if (newScrollPos === elementScrollWidth - elementWidth) {
            this.setState({
                showLeftArrow: true,
                showRightArrow: false
            });
        } else {
            this.setState({
                showLeftArrow: true,
                showRightArrow: true
            });
        }
    }

    state = {
        showLeftArrow: false,
        showRightArrow: true
    };

    constructor(props) {
        super(props);
        this.teasers = React.createRef();
    }

    componentDidMount() {
        this.scrollToSelectedTeaser();
    }

    render() {
        return (
            <div className={css.teasersWrapper}>
                <div className={css.teasers} ref={this.teasers}>
                    {this.props.children}
                </div>
                {this.props.children.length > 4 && (
                    <React.Fragment>
                        {this.state.showLeftArrow && (
                            <div className={`${css.arrowButton} ${css.arrowLeft}`} onClick={() => this.scroll('left')}>
                                <Boomerang />
                            </div>
                        )}
                        {this.state.showRightArrow && (
                            <div className={`${css.arrowButton} ${css.arrowRight}`} onClick={() => this.scroll('right')}>
                                <Boomerang />
                            </div>
                        )}
                    </React.Fragment>
                )}
            </div>
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    VideoSeriesCarousel.propTypes = {
        carouselStartPos: PropTypes.number,
        children: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.number,
                isSelected: PropTypes.bool,
                format: PropTypes.string
            })
        )
    };
}

export default VideoSeriesCarousel;
